//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { catchError, map, Observable, throwError } from 'rxjs';
import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BalanceProviderInfo, BOKKZ_BASE_URL } from '@snelstart-ventures/fiscaal/domain-logic';

export interface CombinedItem {
  id: string;
  clientId?: number;
  sstRelationId?: string;
  taxId?: string;
  taxIdVat?: string;
  taxIdWageTax?: string;
  achternaam?: string;
  isClient: boolean;
}

export interface ClientMerge {
  targetId?: string;
  sourceIds?: string[];
}

export interface ClientSplit {
  currentUserId: string; // UUID of the current user
  archivedUserId: string; // UUID of the archived user
  taxSelection: TaxSelection; // Object representing which tax items to split
}

export interface TaxSelection {
  valueAddedTax: boolean;
  incomeTax: boolean;
  corporateTax: boolean;
  wageTax: boolean;
  dossiers: boolean;
  bezwaar: boolean;
  salaris: boolean;
  dividend: boolean;
  gifttax: boolean;
  digipoort: boolean;
}

export interface Credentials {
  username?: string;
  password?: string;
  email?: string;
  beconnummer?: string;
  provider?: Provider;
  id: string;
  code: string;
  sessionId: string;
  loggedIn: boolean;
  twoFactor: boolean;
  active: boolean;
  succes: boolean;
}

export enum Provider {
  FiscaalGemak = 'Fiscaal Gemak',
  Nextens = 'Nextens'
}

@Injectable({
  providedIn: 'root'
})
export class BokkzAlgemeenClient {
  private http: HttpClient;
  private readonly baseUrl: string;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BOKKZ_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  getBalanceProviders(): Observable<BalanceProviderInfo[]> {
    let url_ = this.baseUrl + '/api/v1/sst/balanceproviders';

    url_ = url_.replace(/[?&]$/, '');

    const options_ = {
      observe: 'response' as const,
      responseType: 'json' as const,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    };

    return this.http.request('GET', url_, options_).pipe(
      catchError((error: any) => this.handleError(error)),
      map((response) => response.body as BalanceProviderInfo[])
    );
  }

  postClientList(formBody: FormData): Observable<Response> {
    const url = `${this.baseUrl}/api/v1/sst/intermediary/clientlist`;
    return this.http
      .post<Response>(url, formBody, {
        observe: 'response',
        responseType: 'json'
      })
      .pipe(
        map((response) => response.body as Response),
        catchError((error: any) => this.handleError(error))
      );
  }

  getLoginStatus(): Observable<Credentials> {
    let url = `${this.baseUrl}/api/v1/data/login`;
    // let url = `http://localhost:8086/api/v1/data/login`;

    url = url.replace(/[?&]$/, '');

    const options_ = {
      observe: 'response' as const,
      responseType: 'json' as const,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    };

    return this.http.request('GET', url, options_).pipe(
      catchError((error: any) => this.handleError(error)),
      map((response) => response.body as Credentials)
    );
  }

  postCredentials(credentials: Credentials): Observable<Credentials> {
    let url = `${this.baseUrl}/api/v1/data/login`;
    // let url = `http://localhost:8086/api/v1/data/login`;

    url = url.replace(/[?&]$/, '');

    return this.http
      .post<Credentials>(url, credentials, {
        observe: 'response',
        responseType: 'json'
      })
      .pipe(
        map((response) => response.body as Credentials),
        catchError((error: any) => this.handleError(error))
      );
  }

  postCredentialsTwoFactor(credentials: Credentials): Observable<Credentials> {
    let url = `${this.baseUrl}/api/v1/data/complete`;
    // let url = `http://localhost:8086/api/v1/data/complete`;

    url = url.replace(/[?&]$/, '');

    return this.http
      .post<Credentials>(url, credentials, {
        observe: 'response',
        responseType: 'json'
      })
      .pipe(
        map((response) => response.body as Credentials),
        catchError((error: any) => this.handleError(error))
      );
  }

  postClientMerge(formBody: ClientMerge): Observable<Response> {
    const url = `${this.baseUrl}/api/v1/sst/client/merge`;
    return this.http
      .post<Response>(url, formBody, {
        observe: 'response',
        responseType: 'json'
      })
      .pipe(
        map((response) => response.body as Response),
        catchError((error: any) => this.handleError(error))
      );
  }

  postClientSplit(formBody: {
    currentUserId: string;
    archivedUserId: string;
    taxSelection: Record<
      | 'valueAddedTax'
      | 'incomeTax'
      | 'corporateTax'
      | 'wageTax'
      | 'dossiers'
      | 'bezwaar'
      | 'salaris'
      | 'dividend'
      | 'gifttax'
      | 'digipoort',
      boolean
    > & {
      [p: string]: boolean;
    };
  }): Observable<Response> {
    const url = `${this.baseUrl}/api/v1/sst/client/split`;
    return this.http
      .post<Response>(url, formBody, {
        observe: 'response',
        responseType: 'json'
      })
      .pipe(
        map((response) => response.body as Response),
        catchError((error: any) => this.handleError(error))
      );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error(`HTTP error ${error.status}:`, error);
    return throwError(() => error);
  }

}
